const globalVars = {
  win: window,
  receptionist: {},
  wpaDetail: {},
  getSignTData: {},
  kfChangeTip: 0,
  isGetSignT: 0,
  isRegOK: 0,
  // msgSyncSum: 0,
  isMobile: 0,
  isChangeKF: 0,
  inRegProcess: 0,
  isRealSendMsg: 1,
  // isInIframe: isInIframe,
  isInIframe: false,
  // defaultAvatar: CONF.CGI_URL.COMP_SOURCE_URL + 'img/default-avatar.png',
  defaultAvatar: '',
  // imageLoadFail: CONF.CGI_URL.COMP_SOURCE_URL + 'img/image-load-fail.png',
  imageLoadFail: '',
  reSendC2bMsg: null,
  ioLinkStatus: null,
  regSuccessCallBack: null,
  imStatus: 'open',
  pageStatus: 'show',
  clickName: 'click',
  // chatSocket: new Socket(),
  chatSocket: {},
  c2bDBsaveData: [],
  c2bSeqGroup: [],
  authConfig: {
    auth: 0,
  },
  menuDetail: {
    active: 0,
    currentVersion: '',
    eLogo: '',
    eName: '',
    defaultConfig: {
      active: 0,
    },
  },
  seqs: {
    key: '',
    data: [],
  },
  getSigTData: {},
  originRoleValue: null,
  clientPingTimer: null,
  serverClientTimeDiff: 0,
  htReportOpts: {
    flag1: 21873,
    flag2: 1,
  },
  registerType: 'default',
  /**
     * 路由通路开启和关闭集合，目前只有QQ通路的开关
     * isCorpUin 0-QQ工号通路 1-QQ主号通路
     * isNeedQQ 0-不显示QQ通路 1-显示QQ通路
     */
  routePermit: {
    isCorpUin: 0,
    isNeedQQ: 1,
  },
  // WebIM界面展示语言
  lang: 'zh-cn',
  // WebIM C侧使用语言
  translateLang: 'zh',
  // 微信内相关配置
  wxConfig: {
    // 是否支持微信语音消息
    enableVoice: false,
    // 微信公众号appid
    appid: '',
    // 微信公众号openid
    openid: '',
  },
  externalType: 1, // weibm对外形象展示 1-企业形象 2-员工形象
  isShowQidianSign: 1, // 是否展示引流入口
  // 第三方应用信息
  thirdAppConfig: {
    enable: false,
    type: '', // wx_mp-微信公众号 wx_mini-微信小程序
    appType: 0, // 1-微信公众号 2-微信小程序
    appId: '',
    openId: '',
    userInfo: {}, // 第三方用户信息
  },
};
const userAgent = globalVars.win.navigator.userAgent.toLocaleLowerCase();
globalVars.userAgent = userAgent;
export { globalVars };
